import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { InfoStep } from '../backend-process/backend-process-presentation/backend-process-presentation.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TimelineComponent } from '../timeline/timeline.component';
import { TimelineItemComponent } from '../timeline/timeline-item/timeline-item.component';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { NgTemplateOutlet } from '@angular/common';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-next-steps',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './next-steps.component.html',
  imports: [TimelineComponent, TimelineItemComponent, BasicCardComponent, NgTemplateOutlet, TranslatePipe, SafeHtmlPipe],
})
export class NextStepsComponent {
  readonly asCard = input<boolean>(false);
  readonly processTitle = input<string>('');
  readonly infoSteps = input<InfoStep[]>([]);
  readonly stepsTitle = input<string>('summary.whatNext');

  readonly formattedSteps = computed(() =>
    this.infoSteps().map(step => {
      return {
        ...step,
        label: Array.isArray(step.label) ? step.label : [step.label],
      };
    }),
  );
}
